// VantaBackground.jsx
import React, { useEffect, useRef, useState } from "react";
import * as THREE from "three";
import GLOBE from "vanta/dist/vanta.globe.min";

const VantaBackground = ({
  color = 0x0d47a1,
  backgroundColor = 0x000000,
  scale = 1.4,
  scaleMobile = 1.0
}) => {
  const vantaRef = useRef(null);
  const vantaEffectRef = useRef(null); // Use a ref to store the Vanta effect instance
  const [hasError, setHasError] = useState(false);

  useEffect(() => {
    if (vantaRef.current && !hasError) {
      try {
        // Destroy existing effect if it exists before creating a new one
        if (vantaEffectRef.current) {
          vantaEffectRef.current.destroy();
        }

        vantaEffectRef.current = GLOBE({ // Store the effect in the ref
          el: vantaRef.current,
          THREE,
          mouseControls: true,
          touchControls: true,
          gyroControls: false,
          scale,
          scaleMobile,
          color,
          backgroundColor,
        });
      } catch (error) {
        console.warn("WebGL context creation failed, falling back to gradient background:", error);
        setHasError(true);
      }
    }

    return () => {
      // Cleanup: destroy the Vanta effect when the component unmounts
      if (vantaEffectRef.current) {
        try {
          vantaEffectRef.current.destroy();
        } catch (error) {
          console.warn("Error destroying Vanta effect:", error);
        }
      }
    };
  }, [color, backgroundColor, scale, scaleMobile, hasError]); // Dependencies remain the same

  // Fallback gradient background if WebGL fails
  if (hasError) {
    return (
      <div
        className="absolute top-0 left-0 w-full h-full bg-gradient-to-br from-blue-900 via-black to-purple-900"
      />
    );
  }

  return (
    <div
      ref={vantaRef}
      className="absolute top-0 left-0 w-full h-full"
    />
  );
};

export default VantaBackground;